// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Cwik","placeholdersHeader":"styles_placeholdersHeader__1iRB5","editorStyle":"styles_editorStyle__W75p9","placeholdersBox":"styles_placeholdersBox__3g-Wv"};